import styled from "styled-components";
import { colors, text } from "~/assets/js/theme/constants";

export const StyledAlert = styled.div`
    width: 375px;
    padding: 16px;
    background-color: ${colors.WHITE};
    border-radius: 12px;
`;

export const CloseButton = styled.div`
    display: flex;
    flex-direction: row-reverse;
`;

export const Image = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    > img {
        padding: 10px;
        object-fit: cover;
        object-position: center;
    }
`;

export const Header = styled.div`
    margin: 12px;
    margin-top: 20px;
    text-align: center;
    font-family: ${text.HEADLINE.FONT};
    font-weight: ${text.HEADLINE.WEIGHT};
    font-size: 21px;
    line-height: 25px;
    padding: 0 8px;
`;

export const Content = styled.div`
    text-align: center;
    font-family: ${text.REGULAR.FONT};
    font-weight: ${text.REGULAR.WEIGHT};
    font-size: 16px;
    line-height: 23px;
    padding: 0 8px;
`;

export const ButtonContainer = styled.div`
    margin-top: 20px;
`;
